import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';
import { Fieldset } from 'primereact/fieldset';
import { TravelStatus } from '../../common/util/constants';
import { toast } from "react-toastify";
import { travelService } from '../../services/extensions';
import { Dialog } from "primereact/dialog";
import { Card } from 'react-bootstrap';
import { Panel } from 'primereact/panel';
// import { Timeline } from 'primereact/timeline';
import moment from 'moment';

import RejectTravelDialog from './RejectTravelDialog';

// const progressStatus = ['Manager ', 'BU ', 'HR ', 'CEO '];

const UserWiseApproval = () => {
    const [usersBySuperior, setUsersBySuperior] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [reviewTravels, setReviewTravels] = useState([]);
    const [selectedTravel, setSelectedTravel] = useState([]);
    const [approvedTravels, setApprovedTravels] = useState([]);
    const [rejectedTravels, setRejectedTravels] = useState([]);
    const [userDetails, setUserDetails] = useState(null); // State to hold user details
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [rejectDialogVisible, setRejectDialogVisible] = useState(false);
    const [selectedTravelDetail, setSelectedTravelDetail] = useState(null);
    const [rejectRowData, setRejectRowData] = useState(null);
    useEffect(() => {
        fetchUsersBySuperior();
    }, []);

    useEffect(() => {
        if (selectedUser.id) {
            fetchAllTravelRecords(selectedUser.id);
        }
    }, [selectedUser]);

    const fetchUsersBySuperior = async () => {
        try {
            const response = await travelService.GetUserReviewtravelBySuperior();
            const formattedUsers = response.data.data.map(user => ({
                id: user.id,
                name: `${user.firstName.charAt(0).toUpperCase()}${user.firstName.slice(1)} ${user.lastName.charAt(0).toUpperCase()}${user.lastName.slice(1).trimEnd()}`,
            }));
            setUsersBySuperior(formattedUsers);
            if (formattedUsers.length > 0) setSelectedUser(formattedUsers[0]);
        } catch (error) {
            console.error('Error fetching users by superior', error);
        }
    };

    const fetchAllTravelRecords = async (userId) => {
        try {
            const response = await travelService.getUserTravelDetailsById(userId);
            const { userDetails, travelRecords } = response.data.data;

            // Add ECN to each travel record if not present
            const travelsWithECN = travelRecords.map(travel => ({
                ...travel,
                ecn: userDetails.ecn // Assuming ecn is part of userDetails
            }));

            setUserDetails(userDetails); // Set user details in the state
            setReviewTravels(travelsWithECN.filter(el => el.status === TravelStatus.SUBMITTED_TO_APPROVER));
            setApprovedTravels(travelsWithECN.filter(el => el.status === TravelStatus.APPROVED_BY_MANAGER));
            setRejectedTravels(travelsWithECN.filter(el => el.status === TravelStatus.REJECTED_BY_MANAGER));
        } catch (error) {
            console.error('Error fetching travel records', error);
        }
    };

    const handleApproveReject = async (travels, actionType) => {
        const requestBody = [{
            reason: actionType === 'approve' ? 'APPROVED' : 'REJECTED',
            status: actionType === 'approve' ? TravelStatus.APPROVED_BY_MANAGER : TravelStatus.REJECTED_BY_MANAGER,
            userId: selectedUser.id,
            travels: travels.map(travel => travel.id),
        }];

        try {
            const response = await travelService.ApproveRejecttravelBulk(requestBody);
            console.log('Approve/Reject operation response:', response);
            toast.success(`Travel requests have been ${actionType === 'approve' ? 'approved' : 'rejected'}`);
            fetchAllTravelRecords(selectedUser.id);
        } catch (error) {
            toast.error(`Unable to ${actionType} travel requests: ${error.message}`);
            console.error('Error during approve/reject operation', error);
        }
    };

    const approveAll = () => handleApproveReject(selectedTravel, 'approve');
    const rejectAll = () => handleApproveReject(selectedTravel, 'reject');

    const handleRejectTravel = (reason) => {
        if (rejectRowData) {
            handleApproveReject([rejectRowData], 'reject', reason);
        } else {
            handleApproveReject(selectedTravel, 'reject', reason);
        }
        setRejectDialogVisible(false);
    };
    const requestedDateTemplate = (rowData) => {
        const date = new Date(rowData.createdAt);
        return date.toLocaleDateString();
    };

    const userNameTemplate = () => {
        return `${userDetails.firstName} ${userDetails.lastName}`;
    };

    const Designationtitle = () => {
        return <div><p>{userDetails?.Designation?.title}</p></div>
    };

    const BusinessUnittitle = () => {
        return <div><p>{userDetails?.BusinessUnit?.title}</p></div>
    };

    const projectBodyTemplate = () => {
        return (
            <React.Fragment>
                {userDetails?.Allocations?.map(allocation => (
                    <div key={allocation.id}>
                        {allocation.Project?.title} ({allocation.percentage}%)
                    </div>
                ))}
            </React.Fragment>
        );
    };
    const lastApprovedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            const date = new Date(rowData.Travels[0].updatedAt);
            return date.toLocaleDateString();
        }
        return 'N/A';
    };
    const journeyDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            const journeyDate = rowData.Travels[0].journeyDate;
            return journeyDate ? moment(journeyDate).format('DD/MM/YYYY') : 'N/A';
        }
        return 'N/A';
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2" onClick={() => handleApproveReject([rowData], 'approve')} tooltip="Approve" />
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger mr-2" onClick={() => { setRejectDialogVisible(true); setRejectRowData(rowData); }} tooltip="Reject" />
                {/* <Button icon="pi pi-times" className="p-button-rounded p-button-danger mr-2" onClick={() => handleApproveReject([rowData], 'reject')} tooltip="Reject" /> */}
                <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary mr-2" onClick={() => setVisible(true)} />
            </React.Fragment>
        )
    };

    const changeUser = (op) => {
        const curIndex = usersBySuperior.indexOf(selectedUser);
        let result = {};
        if (op === 1) {
            // Next Action
            if (curIndex < usersBySuperior.length - 1) {
                result = usersBySuperior[curIndex + 1];
            } else {
                result = usersBySuperior[0];
            }
        } else {
            // Previous Action
            if (curIndex > 0) {
                result = usersBySuperior[curIndex - 1];
            } else {
                result = usersBySuperior[usersBySuperior.length - 1];
            }
        }
        setSelectedUser(result);
    };

    const userOptionTemplate = (data) => {
        return (
            <div className="user-item grid">
                <div className="icon">
                    {data.icon == null ? (
                        <span>{data.name.substr(0, 1)}</span>
                    ) : (
                        <img src={data.icon} />
                    )}
                </div>
                <div className="label col">{data.name}</div>
            </div>
        );
    };
    const selectedUserTemplate = (data, props) => {
        if (data) {
            return (
                <div className="user-item user-item-value grid">
                    <div className="icon">
                        {data.icon == null ? (
                            <span>{data.name.substr(0, 1)}</span>
                        ) : (
                            <img src={data.icon} />
                        )}
                    </div>
                    <div className="label col p-2">{data.name}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    return (
        <>
            <div className="field">
                <div className="tabview-demo">
                    <Fieldset>
                        <h1>Team Members - User Wise Travel</h1>
                        <div className="formgrid grid mt-4">
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: 'center', width: '100%', flexWrap: 'wrap'}}>
                                <div className="field">
                                    <Button label="Previous User" icon="pi pi-angle-left" className="p-button-rounded" onClick={() => changeUser(-1)} />
                                </div>
                                <div className="field">
                                    <Dropdown value={selectedUser} options={usersBySuperior} onChange={(e) => setSelectedUser(e.value)} optionLabel="name" placeholder="Select a User" itemTemplate={userOptionTemplate} valueTemplate={selectedUserTemplate} style={{ width: "300px" }} />
                                </div>
                                <div className="field">
                                    <Button label="Next User" icon="pi pi-angle-right" iconPos="right" className="p-button-rounded" onClick={() => changeUser(1)} />
                                </div>
                            </div>
                            <TabView className="col-12 mt-4 mobile_table" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                <TabPanel header="Review Travel">
                                    <DataTable value={reviewTravels} selection={selectedTravel} onSelectionChange={(e) => setSelectedTravel(e.value)} paginator rows={4} currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                                        <Column header="Requested Date" body={requestedDateTemplate} />
                                        <Column header="ECN" field='ecn' />
                                        <Column header="User Name" body={userNameTemplate} />
                                        <Column header="Designation" body={Designationtitle} />
                                        <Column header="BU" body={BusinessUnittitle} />
                                        <Column header="Project" body={projectBodyTemplate} />
                                        <Column header="Travel Date" body={requestedDateTemplate} />
                                        <Column header="Action" body={actionBodyTemplate} />
                                    </DataTable>
                                    <div className="flex mt-4">
                                        <Button label="Approve All" className="p-button-success mr-2" onClick={approveAll} disabled={selectedTravel.length === 0} />
                                        <Button label="Reject All" className="p-button-danger" onClick={rejectAll} disabled={selectedTravel.length === 0} />
                                    </div>
                                </TabPanel>
                                <TabPanel header="Approved Travel">
                                    <DataTable value={approvedTravels} paginator rows={10} currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                                        <Column header="Requested Date" body={requestedDateTemplate} />
                                        <Column header="ECN" field='ecn' />
                                        <Column header="User Name" body={userNameTemplate} />
                                        <Column header="Designation" body={Designationtitle} />
                                        <Column header="BU" body={BusinessUnittitle} />
                                        <Column header="Project" body={projectBodyTemplate} />
                                        <Column header="Travel Date" body={requestedDateTemplate} />
                                        <Column field="appdate" header="Last Approved Date" body={lastApprovedDateTemplate} />
                                    </DataTable>
                                </TabPanel>
                                <TabPanel header="Reject Travel">
                                    <DataTable value={rejectedTravels} paginator rows={10} currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                                        <Column header="Requested Date" body={requestedDateTemplate} />
                                        <Column header="ECN" field='ecn' />
                                        <Column header="User Name" body={userNameTemplate} />
                                        <Column header="Designation" body={Designationtitle} />
                                        <Column header="BU" body={BusinessUnittitle} />
                                        <Column header="Project" body={projectBodyTemplate} />
                                        <Column header="Travel Date" body={journeyDateTemplate} />
                                        <Column field="rejdate" header="Rejected Date" body={lastApprovedDateTemplate} />
                                    </DataTable>
                                </TabPanel>
                            </TabView> 
                        </div>
                    </Fieldset>
                    <Dialog header="Travel Detail" visible={visible} style={{ width: '95vw' }} onHide={() => setVisible(false)}>
                        {selectedTravelDetail && (
                            <div>
                                <div className="flex flex-column w-70">
                                    {/* Assuming progressStatus is a timeline or progress indicator */}
                                    {/* <Timeline value={progressStatus} layout="horizontal" align="bottom" content={(item) => item} opposite={<span>&nbsp;</span>} /> */}
                                </div>
                                <Panel className='traveldetail'>
                                    <div className='formgrid grid'>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Travel Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-2 single-category'>
                                                        <h2>Trip Type</h2>
                                                        <p>{selectedTravelDetail?.tripTypeInfo?.title}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Visa Type</h2>
                                                        <p>{selectedTravelDetail?.visaTypeInfo?.title}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>User ECN</h2>
                                                        <p>{selectedTravelDetail?.empEcn}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Manager ECN</h2>
                                                        <p>{selectedTravelDetail?.managerEcn}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Traveller Name</h2>
                                                        <p>{selectedTravelDetail?.givenName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Traveller Initiated By</h2>
                                                        <p>{userDetails?.firstName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Surname</h2>
                                                        <p>{selectedTravelDetail?.lastName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Given Name</h2>
                                                        <p>{selectedTravelDetail?.givenName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Designation</h2>
                                                        <p>{userDetails?.Designation?.title}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Mobile Number</h2>
                                                        <p>{userDetails?.mobileNumber}</p>
                                                    </div>
                                                    <div className='field col-4 single-category'>
                                                        <h2>Email ID</h2>
                                                        <p>{userDetails?.email}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Grade</h2>
                                                        <p>{selectedTravelDetail?.grade}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Traveller Comments</h2>
                                                        <p>{selectedTravelDetail?.comment}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Traveller Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-2 single-category'>
                                                        <h2>Client Name</h2>
                                                        <p>{selectedTravelDetail?.clientId}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Project Name</h2>
                                                        <p>{selectedTravelDetail?.projectId}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Project Manager</h2>
                                                        <p>{userDetails?.managerName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>BU/Functional Head</h2>
                                                        <p>{userDetails?.buHead}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Country of visit</h2>
                                                        <p>{selectedTravelDetail?.countryofVisit}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>State/Cities</h2>
                                                        <p>{selectedTravelDetail?.states}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Journey Date</h2>
                                                        <p>{moment(selectedTravelDetail?.journeyDate).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Return Date</h2>
                                                        <p>{moment(selectedTravelDetail?.returnDate).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Cost Center</h2>
                                                        <p>{selectedTravelDetail?.costCenter}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>DA Currency</h2>
                                                        <p>{selectedTravelDetail?.daCurrency}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>DA Entitle Amount</h2>
                                                        <p>{selectedTravelDetail?.daentitleAmmount}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Seat Request</h2>
                                                        <p>{selectedTravelDetail?.seatRequest}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Meal Request</h2>
                                                        <p>{selectedTravelDetail?.mealRequest}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Frequently Flyer Number</h2>
                                                        <p>{selectedTravelDetail?.frequentflyerNumber}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Passport Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-2 single-category'>
                                                        <h2>Passport Number</h2>
                                                        <p>{selectedTravelDetail?.travelDetails[0]?.passportNumber}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Date of Birth</h2>
                                                        <p>{moment(selectedTravelDetail?.travelDetails[0]?.dateOfBirth).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Place of Issue</h2>
                                                        <p>{selectedTravelDetail?.travelDetails[0]?.placeOfIssue}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Date of Issue of Passport</h2>
                                                        <p>{moment(selectedTravelDetail?.travelDetails[0]?.dateOfIssueOfPassport).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Date of Expiry of Passport</h2>
                                                        <p>{moment(selectedTravelDetail?.travelDetails[0]?.dateOfExpiryOfPassport).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                    </div>
                                </Panel>
                            </div>
                        )}
                    </Dialog>
                    <RejectTravelDialog
                        visible={rejectDialogVisible}
                        onHide={() => setRejectDialogVisible(false)}
                        onSubmit={handleRejectTravel}
                    />
                </div>
            </div>
        </>
    );
};

export default UserWiseApproval;
